import React from 'react'
import Flit from '../flit/Flit'
import "./Scrib.css"
import Tilt from 'react-tilt'
const Scrib = () => {
    return (
        <div className='flex flex-col flex-wrap relative w-full h-auto   '>
            <div className='container mx-auto flex flex-col flex-wrap justify-center items-center'>
                {/* <div className='flex flex-wrap flex-col text-white mt-10 justify-center items-center '>
                    <h2 className=' font-medium text-5xl'>Get your Scrib</h2>
                     <div className='flex flex-col flex-wrap mt-10 border-[1px] px-20  py-5 font-iceberg  justify-center items-center btn_dog relative z-0 cursor-pointer'>
                        <button className='tracking-[5px] text-2xl text-orange-500 z-10'>Buy on openea</button>
                    </div> 
                </div> */}
                <div className='flex flex-col  text-white  w-full h-auto mt-24'>
                    <div className=' flex flex-row  w-full h-auto' id="story">
                        <div className='  w-1/2  items-end  flex flex-col h-auto  relative'>
                            <div className=' flex flex-col w-full justify-end  items-end h-full mx-20'>
                                <Tilt className="Tilt  w-[70%] h-full   rounded-t-2xl   " options={{ max: 25 }} >
                                    <div className=" flex flex-row  w-[70%] h-full  ">
                                            <img src={require("../../assets/images/hero.gif")} className=' cursor-pointer flip w-[80%] Tilt-inner h-full' alt={"slide"} />
                                    </div>

                                </Tilt>
                            </div>
                        </div>
                        <div className='w-1/2   h-full   flex flex-col flex-wrap items-start relative  '>
                            <div className='flex flex-col border-t-[2px] border-slate-800 border-l-[2px] px-4 py-4 flex-wrap'>
                                <h5 className='  text-xl uppercase font-iceberg'>Scrib</h5>
                            </div>
                            <div className=' flex flex-col flex-wrap mt-4 font-iceberg'>

                                <h3 className=' text-5xl'>What are Scribs?</h3>
                            </div>
                            <div className=' flex flex-col w-[60%] flex-wrap mt-10  text-white justify-center items-start'>
                                <p>
                                    Recognizable by most anyone who has spent countless hours in a classroom scribbling away, the Scribs resonate with millions. Were its origins in ancient Egypt, Greece, Mesopotamia…no one really knows. In modern times some schools attempted to ban it, claiming it to be a gang symbol or some form of a cult. The Scrib has persevered, and has grown to become one of the most recognizable symbols in the world.

                                </p>
                            </div>

                            <div className='flex flex-col flex-wrap mt-10 border-[1px] px-20  py-5 font-iceberg  justify-center items-center  relative cursor-pointer'>
                                <button className='tracking-[5px] text-2xl text-white uppercase btn_discord '>Join our discord</button>
                            </div>

                        </div>
                    </div>

                    <div className=' flex flex-row flex-wrap w-full h-auto mt-20' id="about">
                        <div className='w-1/2   h-full   flex flex-col flex-wrap items-end relative pr-[70px] '>
                            <div className='flex flex-col border-t-[2px] border-slate-800 border-r-[2px] px-4 py-4 flex-wrap'>
                                <h5 className='  text-xl uppercase font-iceberg'>About us</h5>
                            </div>
                            <div className=' flex flex-col flex-wrap mt-4 font-iceberg'>

                                <h3 className=' text-5xl'>Project Description</h3>
                            </div>
                            <div className=' text-end flex flex-col w-[60%] flex-wrap mt-10  text-white justify-center items-start'>
                                <p>The animated Scribs are a unique collection of 10,000 rotating NFT’s. There are nearly 200 unique traits dispersed amongst the entire collection, with four defined tiers of rarity, up to the ultra-rare, Mystical level, traits which include a very small group of reverse rotating Scribs. Scribs are stored as ERC-271 tokens on the Ethereum blockchain hosted on an IPFS. Our goal in developing the Scribs is to bring together all those who have had a connection with the Scrib from their school and build a community that can share their common experiences.</p>

                            </div>

                            <div className='flex flex-col flex-wrap mt-10 border-[1px] px-20  py-5 font-iceberg  justify-center items-center  relative cursor-pointer'>
                                <button className='tracking-[5px] text-2xl text-white uppercase btn_discord '>Join our discord</button>
                            </div>

                        </div>
                        <div className='  w-[40%]  flex flex-col flex-wrap justify-center items-start  '>
                            <div className='flex flex-row mb-8 w-full h-auto  justify-between  items-center'>
                                <Flit />
                                <Flit />
                            </div>
                            <div className='flex flex-row  w-full h-auto  justify-between items-center'>
                                <Flit />
                                <Flit />
                            </div>
                        </div>

                    </div>
                   

                </div>

            </div>
        </div>
    )
}

export default Scrib